/* eslint-disable no-unused-vars */
import styled from "styled-components";
import colors from "../../../../../../../styles/colorPalette";
import shadows from "../../../../../../../styles/shadesPalette";

export const Input = styled.input`
  width: 298px;
  height: 30px;
  padding-left: 5px;
  border: 1px solid ${colors.gray3};
  border-radius: 4px;
  font-family: "OpenSansRegular";
  font-style: normal;
  color: black;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.18px;
  outline: none;
  border: ${(props) => (!props.error ? `1px solid ${colors.blue1}` : `1px solid ${colors.red1}`)};
  &:focus {
    border: ${(props) => (!props.error ? `1px solid ${colors.blue1}` : `1px solid ${colors.red1}`)};
    -webkit-transition: 0.5s;
    transition: 0.5s;
    outline: none;
  }
  @media (max-width: 1400px) {
    width: 268px;
    height: 25px;
    line-height: 18px;
    font-size: 15px;
  }
`;
